import React, { createContext, useState } from "react";

const defaultValue = {
  name: "",
  phone: "",
  email: "",
  valorUf: "",
  montoArriendo: 0,
  montoGarantia: 0,
  primaBrutaAnual: 0,
  activacionCuenta: 1.5,
  totalPagar: 1.5,
  totalPagarApp: "0",
  inmobilizacion: "0",
  rut: "",
  pasaporte: "",
  region: "",
  comuna: "",
  comentarios: "",
};

export const MyFormContext = createContext();

const FormContext = ({ children }) => {
  const [form, setForm] = useState(defaultValue);
  return (
    <MyFormContext.Provider value={{ form, setForm }}>
      {children}
    </MyFormContext.Provider>
  );
};

export default ({ element }) => <FormContext>{element}</FormContext>;
